export default {
  SET_ORG(state, org) {
    state.org = org;
  },
  SET_ORG_CAMERAS(state, cameras) {
    state.cameras = cameras;
  },
  SET_ORG_SHARED_CAMERAS(state, sharedCameras) {
    state.sharedCameras = sharedCameras;
  },
  SET_ORG_INTERCOMS(state, intercoms) {
    state.intercoms = intercoms;
  },
  SET_OPERATOR_PARAMETERS(state, payload) {
    state.operatorParameters = payload;
  },
};
